import { render } from "./EmailCardV2.vue?vue&type=template&id=6d4dbcf8&scoped=true"
import script from "./EmailCardV2.vue?vue&type=script&lang=js"
export * from "./EmailCardV2.vue?vue&type=script&lang=js"

import "./EmailCardV2.vue?vue&type=style&index=0&id=6d4dbcf8&lang=scss"
import "./EmailCardV2.vue?vue&type=style&index=1&id=6d4dbcf8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d4dbcf8"]])

export default __exports__